import React, { Component } from "react";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import { intersection } from "lodash";
import TextField from "../fields/TextField";
import SelectField from "../fields/SelectField";
import BooleanField from "../fields/BooleanField";
import { buildOptions } from "../utils";
import PastOccupancyFormModal from "../PastOccupancies/PastOccupancyFormModal";
import PastOccupancyList from "../PastOccupancies/PastOccupancyList";
import TreatmentCenterFormModal from "../TreatmentCenters/TreatmentCenterFormModal";
import TreatmentCenterList from "../TreatmentCenters/TreatmentCenterList";
import OccupationFormModal from "../Occupations/OccupationFormModal";
import OccupationList from "../Occupations/OccupationList";
import FamilyMemberList from "../FamilyMembers/FamilyMemberList";
import TherapistFormModal from "../Therapists/TherapistFormModal";
import TherapistList from "../Therapists/TherapistList";
import LivingArrangementFormModal from "../LivingArrangements/LivingArrangementHistoryFormModal";
import LivingArrangementList from "../LivingArrangements/LivingArrangementHistoryList";
import SobrietyFormModal from "../Sobrieties/SobrietyFormModal";
import SobrietyList from "../Sobrieties/SobrietyList";
import PaymentsFormModal from "../modals/PaymentsFormModal";
import MedicalHistoryFormModal from "../modals/MedicalHisotryFormModal";
import RecoveryHistoryFormModal from "../modals/RecoveryHistoryFormModal";
import DemographicsFormModal from "../modals/DemographicsFormModal";
import ContactList from "../Contacts/ContactList";
import SoberLivingList from "../SoberLivings/SoberLivingList";
import ModalButton from "../ModalButton";
import Section from "../Section";
import DischargeModal from "../CurrentOccupancies/DischargeModal";
import EducationFormModal from "../Education/EducationFormModal";
import EducationList from "../Education/EducationList";
import InsuranceFormModal from "../Insurance/InsuranceFormModal";
import InsuranceList from "../Insurance/InsuranceList";
import { VaccineList } from "../Vaccines/VaccineList";
import { VaccineFormModal } from "../Vaccines/VaccineFormModal";
import { TestList } from "../Tests/TestList";
import { TestFormModal } from "../Tests/TestFormModal";
import FamilyMemberFormModal from "../FamilyMembers/FamilyMemberFormModal";
import ProbationFormModal from "../Probations/ProbationFormModal";
import ProbationList from "../Probations/ProbationList";
import AbuseExperiencesFormModal from "../AbuseExperiences/AbuseExperiencesFormModal";
import AbuseExperiencesList from "../AbuseExperiences/AbuseExperiencesList";
import CriminalHistoryFormModal from "../CriminalHistory/CriminalHistoryFormModal";
import CriminalHistoryListView from "../CriminalHistory/CriminalHistoryListView";
import MedicinalMarijuanaFormModal from "../MedicinalMarijuana/MedicinalMarijuanaFormModal";
import MedicinalMarijuanaListView from "../MedicinalMarijuana/MedicinalMarijuanaListView";
import ChildWelfareHistoryList from "../ChildWelfareHistories/ChildWelfareHistoryList";
import ChildWelfareHistoryFormModal from "../ChildWelfareHistories/ChildWelfareHistoryFormModal";
import CurrentOccupancyFormModal from "../CurrentOccupancies/CurrentOccupancyFormModal";
import CurrentOccupancyList from "../CurrentOccupancies/CurrentOccupancyList";
import MemberList from "../Narr/MemberList";
import CounselingHistoryList from "../CounselingHistories/CounselingHistoryList";
import CounselingHistoryFormModal from "../CounselingHistories/CounselingHistoryFormModal";

class OverviewTab extends Component {
  render() {
    const genderOptions = buildOptions([
      "Male",
      "Female",
      "Trans",
      "Non-Binary",
    ]);
    const maritalStatusOptions = buildOptions([
      "Single",
      "Married",
      "Divorced",
      "Separated",
      "Widowed",
    ]);
    const raceOptions = buildOptions([
      "American Indian or Alaska Native ",
      "Indian",
      "Asian",
      "Black or African American",
      "White",
      "Hispanic",
      "Hawaiian or Other Pacific Islander",
    ]);
    const ethnicityOptions = buildOptions([
      "Hispanic or Latino or Spanish Origin",
      "Not Hispanic or Latino or Spanish Origin",
    ]);
    const meetingOptions = buildOptions([
      "AA",
      "NA",
      "SLAA",
      "CODA",
      "Refuge Recovery",
    ]);
    const veteranStatusOptions = buildOptions([
      "Yes",
      "No",
      "Disabled veteran",
      "Recently separated veteran",
      "Active Duty Wartime or Campaign Badge Veteran",
      "Armed Forces Service Medal Veteran"
    ]);

    const { action, organization, openModal, isStaffApp, permissions } =
      this.props;

    return (
      <div>
        {organization.name !== 'narr-affiliate-account' && (
            <Section
                label="Past Occupancies"
                resources={{
                  occupancies: ["length"],
                }}
            >
              <PastOccupancyFormModal />
              <PastOccupancyList />
            </Section>
        )}

        {organization.name !== 'narr-affiliate-account' && (
            <Section
              label="Current Occupancies"
              resources={{
                occupancies: ["length"],
              }}
            >
              <CurrentOccupancyFormModal />
              <DischargeModal />
              <CurrentOccupancyList />
            </Section>
        )}
        {organization.name === 'narr-affiliate-account' && (
            <MemberList />
        )}
        {intersection(permissions, [
          "use_client_profile",
          "client_profile_tab_overview",
        ]).length == 2 && (
            <>
              <Section
                label="Contacts"
                resources={{
                  contacts: ["length"],
                }}
              >
                <ContactList />
              </Section>



              <Section
                label="Family Members"
                resources={{
                  family_members: ["length"],
                }}
              >
                <FamilyMemberFormModal />
                <FamilyMemberList />
              </Section>
              <Section
                label="Counseling History"
                resources={{
                  counseling_histories: ["length"],
                }}
              >
                <CounselingHistoryFormModal />
                <CounselingHistoryList />
              </Section>
              <Section
                label="Child Welfare History"
                resources={{
                  child_welfare_histories: ["length"],
                }}
              >
                <ChildWelfareHistoryFormModal />
                <ChildWelfareHistoryList />
              </Section>
              <Section
                label="Recovery History"
                resources={{
                  resident: ["step", "kinds_of_meetings_attended_list"],
                  sobrieties: ["length"],
                }}
              >
                <RecoveryHistoryFormModal />
                <>
                  <Row>
                    <TextField name="step" label="Step" action="show" />
                    <SelectField
                      name="kinds_of_meetings_attended_list"
                      label="Kinds of Meetings Attended"
                      options={meetingOptions}
                      action="show"
                      isMulti={true}
                    />
                  </Row>
                  <div className="d-flex justify-content-center">
                    <ModalButton
                      resourceName="recoveryHistory"
                      label="Add/Edit Recovery History"
                    />
                  </div>
                </>
                <SobrietyFormModal />
                <SobrietyList />
              </Section>

              <Section
                label="Medical History"
                resources={{
                  resident: [
                    "diagnosis_list",
                    "substances_of_choice_list",
                    "health_problem_list",
                    "allergy_type_list",
                    "medical_notes",
                  ],
                }}
              >
                <MedicalHistoryFormModal />
                <>
                  <Row>
                    <SelectField
                      name="diagnosis_list"
                      label="Diagnosis"
                      action="show"
                      options={this.props.mental_disorders_options}
                    />
                    <SelectField
                      name="substances_of_choice_list"
                      label="Substances of Choice"
                      action="show"
                      options={this.props.substances_of_choice_options}
                    />
                    <SelectField
                      name="health_problem_list"
                      label="Health Problems"
                      action="show"
                      options={this.props.health_problem_options}
                    />
                    <SelectField
                      name="allergy_type_list"
                      label="Allergies"
                      action="show"
                      options={this.props.allergies_options} />
                    <TextField
                      name="medical_notes"
                      label="Notes"
                      col={12}
                      action="show"
                    />
                  </Row>
                  <div className="d-flex justify-content-center">
                    <ModalButton
                      resourceName="medicalHistory"
                      label="Add/Edit Medical History"
                    />
                  </div>
                </>
              </Section>

              <Section
                resources={{ abuse_experiences: ["length"] }}
                label="Abuse History"
              >
                <AbuseExperiencesFormModal />
                <AbuseExperiencesList />
              </Section>

              <Section resources={{ vaccines: ["length"] }} label="Vaccines">
                <VaccineFormModal />
                <VaccineList />
              </Section>

              <Section resources={{ medical_tests: ["length"] }} label="Tests">
                <TestFormModal />
                <TestList />
              </Section>

              <Section
                label="Therapist/Clinician"
                resources={{
                  therapists: ["length"],
                }}
              >
                <TherapistFormModal />
                <TherapistList />
              </Section>

              <Section
                label="Treatment Center History"
                resources={{
                  treatment_centers: ["length"],
                }}
              >
                <TreatmentCenterFormModal />
                <TreatmentCenterList />
              </Section>

              <Section
                label="Sober Living History"
                resources={{
                  sober_livings: ["length"],
                }}
              >
                <SoberLivingList />
              </Section>

              <Section
                label="Education History"
                resources={{
                  educations: ["length"],
                }}
              >
                <EducationFormModal />
                <EducationList />
              </Section>

              <Section
                label="Employment History"
                resources={{
                  occupations: ["length"],
                }}
              >
                <OccupationFormModal />
                <OccupationList />
              </Section>

              <Section
                label="Living Arrangement History"
                resources={{
                  living_arrangement_histories: ["length"],
                }}
              >
                <LivingArrangementFormModal />
                <LivingArrangementList />
              </Section>

              <Section
                label="Probation History"
                resources={{
                  probations: ["length"],
                }}
              >
                <ProbationFormModal />
                <ProbationList />
              </Section>

              <Section
                label="Demographics"
                resources={{
                  resident: [
                    "gender",
                    "school",
                    "marital_status",
                    "race",
                    "ethnicity",
                    "veteran_status",
                  ],
                }}
              >
                <DemographicsFormModal />
                <>
                  <Row>
                    <SelectField
                      name="gender"
                      label="Gender"
                      options={genderOptions}
                      creatable
                      action="show"
                    />
                    <TextField name="school" label="School" action="show" />
                    <SelectField
                      name="marital_status"
                      label="Marital Status"
                      options={maritalStatusOptions}
                      action="show"
                    />
                    <SelectField
                      name="race"
                      label="Race"
                      options={raceOptions}
                      creatable
                      action="show"
                    />
                    <SelectField
                      name="ethnicity"
                      label="Ethnicity"
                      options={ethnicityOptions}
                      creatable
                      action="show"
                    />
                    <SelectField
                      name="veteran_status"
                      label="Veteran"
                      options={veteranStatusOptions}
                      action="show"
                    />
                  </Row>
                  <div className="d-flex justify-content-center">
                    <ModalButton
                      resourceName="demographics"
                      label="Add/Edit Demographics"
                    />
                  </div>
                </>
              </Section>

              <Section
                label="Insurance"
                resources={{
                  insurances: ["length"],
                }}
              >
                <InsuranceFormModal />
                <InsuranceList />
              </Section>
            </>
          )}

          <Section
            label="Criminal History"
            resources={{
              criminal_history: [
                "involved_with_criminal_system"
              ]
            }}
        >
          <CriminalHistoryFormModal />
          <CriminalHistoryListView />
        </Section>
        {(organization["name"] === 'Transformational-Living-Homes' || organization["name"] === 'sober-homes') && (
            <Section
                label="Medicinal Marijuana"
                resources={{
                  medicinal_marijuana: [
                    "maintenance_card",
                    "maintenance_card_for_pain_management",
                    "form_of_usage"
                  ]
                }}
            >
              <MedicinalMarijuanaFormModal />
              <MedicinalMarijuanaListView />
            </Section>
        )}

        {organization["uses_payment_section?"] && !isStaffApp && (
          <Section
            label="Payments"
            resources={{
              resident: [
                "payment_amount",
                "payment_payer",
                "payment_payer_email",
                "payment_frequency",
                "follow_up_at",
              ],
            }}
          >
            <PaymentsFormModal />
            <Row>
              <TextField
                name="payment_amount"
                label="Payment Amount"
                action="show"
              />
              <TextField name="payment_payer" label="Payer" action="show" />
              <TextField
                name="payment_payer_email"
                label="Payer Email"
                action="show"
              />
              <TextField
                name="payment_frequency"
                label="Payment Frequency"
                action="show"
              />
              <TextField name="follow_up_at" label="Follow up" action="show" />
            </Row>
            <div className="d-flex justify-content-center">
              <ModalButton
                resourceName="payments"
                label="Add/Edit Payment Details"
              />
            </div>
          </Section>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.permissions,
    isStaffApp: state.config.isStaffApp,
    action: state.ui.action,
    organization: state.organization,
    substances_of_choice_options: buildOptions(
      state.org_dependant_data.substances_of_choice_options
    ),
    mental_disorders_options: buildOptions(
      state.org_dependant_data.mental_disorders_options
    ),
    health_problem_options: buildOptions(
      state.org_dependant_data.health_problem_options
    ),
    allergies_options: buildOptions(
      state.org_dependant_data.allergies_options
    )
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openModal: (resourceName) => {
      dispatch({ type: "OPEN_RESOURCE_MODAL", payload: { resourceName } });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OverviewTab);
